import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiResponse, LoginAuthApiNamespace } from '@core/models/api';

import {
  LoginHttpService,
  NavigationService,
  RecaptchaService,
  UIService,
} from '@core/services';
import {
  hasLength,
  hasLowerCase,
  hasNumbers,
  hasUpperCase,
  regexes,
} from '@core/utils';
import { environment } from '@environment';
import { EDeveloperProfile } from '@environment.namespace';
import { TokenService } from '@paypoint-frontend/web-core';

@Injectable()
export class LoginService {
  private navigationService = inject(NavigationService);
  private http = inject(LoginHttpService);
  private uiService = inject(UIService);
  private recaptchaService = inject(RecaptchaService);
  private tokenService = inject(TokenService);

  form = new FormGroup({
    login: new FormControl(
      environment.devProfile === EDeveloperProfile.IANTROPOV_IIS
        ? 'i.morosan@paypoint.md'
        : '' /* 'v.novicov@paypoint.md' */,
      [Validators.required, Validators.pattern(regexes.EMAIL)],
    ),
    password: new FormControl(
      environment.devProfile === EDeveloperProfile.IANTROPOV_IIS
        ? 'Test001&'
        : '' /* 'Test001&' */,
      [
        Validators.required,
        hasLength(),
        hasUpperCase(),
        hasLowerCase(),
        hasNumbers(),
      ],
    ),
  });

  authResponseError = signal<ApiResponse>(new ApiResponse());

  private clearSignals() {
    this.authResponseError.set(new ApiResponse());
  }

  async auth(input: LoginAuthApiNamespace.IN) {
    this.clearSignals();
    this.uiService.freeze();
    input.captchaToken = await this.recaptchaService.captchaGetToken('login');
    return new Promise<void>((resolve) => {
      this.http.auth(input).subscribe({
        next: (output) => {
          this.tokenService.setToken(output.accessToken);
          this.tokenService.setLifeTime(output.expiresAt);
          // localStorage.setItem('userLogin', output.login);
          // this.authService.scheduleLogout();

          this.navigationService.navigateToReportAbonaments();
          this.uiService.unFreeze();
          resolve();
        },
        error: (error: HttpErrorResponse) => {
          const response = new ApiResponse(error);
          this.authResponseError.set(response);
          console.log(response.message);
          this.uiService.unFreeze();
          resolve();
        },
      });
    });
  }
}
